<template>
    <div>
        <v-card light style="width: 100%;height: 100%;display: flex;flex-direction: column;">
            <div class="card-title">数据管理</div>
            <div v-if="listFile==='default'">
                <div class="path-filter">
                    <div style="float: left;display: flex;">
                        <v-btn v-if="path.length>1" text height="32" style="margin: 4px 0px 4px 15px;" @click="returnLastPath">返回上一级  |</v-btn>
                        <v-breadcrumbs :items="path" divider=">">
                            <template v-slot:item="{ item }">
                                <v-breadcrumbs-item>
                                    <v-btn text @click="returnParent(item.id)">{{item.text}}</v-btn>
                                </v-breadcrumbs-item>
                            </template>
                        </v-breadcrumbs>
                    </div>
                    <v-spacer></v-spacer>
                    <v-text-field
                            outlined dense hide-details label="搜索我的影像库数据" append-icon="mdi-magnify"
                            style="width: 200px;" v-model="keyword" @click:append="searchByKeyword" class="search-arrange"
                    ></v-text-field>
                </div>
                <div class="show-select">
                    <v-checkbox hide-details v-model="isSelectAll" :label="'已选中'+selected.length+'个文件/文件夹'"></v-checkbox>
                </div>
                <div class="data-list">
                    <div v-if="noneData" style="display: flex;flex-direction: column;align-items: center;">
                        <img style="width: 160px;height: 120px;" src="/dataLab/该目录下没有文件.png">
                        <div style="margin-top: 10px;font-size: 14px;color: #757575;">该目录下没有文件</div>
                    </div>
                    <vuescroll v-else :ops="ops" style="height: 100%;">
                        <v-list>
                            <v-list-item v-for="item in dataList" :key="item.id" @mouseenter="hoverItem=item.id" @mouseleave="hoverItem=''">
                                <v-checkbox hide-details multiple v-model="selected" :value="item.id"></v-checkbox>
                                <img v-if="item.type==='folder'" src="/gallery/文件夹-展开.png" class="img_style">
                                <img v-else-if="item.packageOperation==false" src="/gallery/其他需求不打包.png" style="margin-left: 4px;width: 18px;margin-top: 5px;height: 18px;">
                                <img v-else-if="item.dataType===1" src="/gallery/压缩包.png" class="img_style">
                                <img v-else-if="item.dataType===2" src="/gallery/切片图标.png" class="img_style">
                                <div
                                        v-if="item.id && renameItem!==item.id" @click="enterFolder(item)"
                                        style="height: 24px;width: 600px;margin-top: 6px;margin-left: 5px;font-size: 14px;"
                                        :class="{ 'color-control': hoverItem===item.id }"
                                >{{item.name}}</div>
                                <v-text-field
                                        hide-details outlined v-model="item.name" v-if="!item.id || renameItem===item.id"
                                        :class="{'color-control': hoverItem===item.id}" class="arrange-item-input" style="flex: none;font-size:14px;"
                                ></v-text-field>
                                <v-btn
                                        small text v-if="!item.id" class="bottom-btn" @click="createFolder(item)"
                                        style="margin-top: 5px;height: 32px;" :disabled="item.name===''" :class="{'button-btn__disabled': item.name===''}"
                                >确定</v-btn>
                                <v-btn
                                        small text v-if="!item.id" @click="dataList.shift(),isCreatingItem=false"
                                        class="bottom-btn" style="margin-top: 5px;height: 32px;"
                                >取消</v-btn>
                                <v-btn
                                        small text class="bottom-btn" style="margin-top: 5px;height: 32px;"
                                        :disabled="item.name===''" :class="{'button-btn__disabled': item.name===''}"
                                        v-if="renameItem===item.id" @click="renameFolder(item)"
                                >确定</v-btn>
                                <v-btn
                                        small text class="bottom-btn" style="margin-top: 5px;height: 32px;"
                                        v-if="renameItem===item.id" @click="renameItem='',item.name=oldName"
                                >取消</v-btn>
                            </v-list-item>
                        </v-list>
                    </vuescroll>
                </div>
                <div class="data-arrange-bottom">
                    <v-btn
                            outlined class="bottom-btn" :disabled="isCreatingItem || renameItem !== ''"
                            :class="{'button-btn__disabled': isCreatingItem || renameItem !== '' }"
                            style="margin-left: 10px;" @click="showNewFolder"
                    >新建文件夹</v-btn>
                    <v-btn
                            outlined class="bottom-btn" @click="buttonState.renameDisabled? '': showRenameFile()"
                            :disabled="buttonState.renameDisabled || isCreatingItem || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.renameDisabled || isCreatingItem || renameItem !== '' }"
                    >重命名</v-btn>
                    <v-btn
                            outlined class="bottom-btn" :disabled="buttonState.moveToDisabled || isCreatingItem || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.moveToDisabled || isCreatingItem || renameItem !== '' }"
                            @click="buttonState.moveToDisabled? '': checkMove()"
                    >移动到</v-btn>
                    <v-btn
                            outlined class="bottom-btn" :disabled="buttonState.deleteDisabled || isCreatingItem || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.deleteDisabled || isCreatingItem || renameItem !== '' }"
                            @click="buttonState.deleteDisabled? '': showDelete()"
                    >删除</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined class="bottom-btn" style="margin-right: 20px;" @click="$store.state.showPanel=false">关闭</v-btn>
                </div>
            </div>
            <div v-else-if="listFile==='moveFile'">
                <div class="path-filter" style="padding: 12px 40px;">移动到</div>
                <div style="width: 100%;height: 390px;">
                    <vuescroll :ops="ops" style="height: 100%;">
                        <v-treeview
                                dense activatable hoverable :active.sync="active" :items="folderList"
                                :open.sync="openList" style="font-size: 14px;"
                        >
                            <template v-slot:prepend="{item}">
                                <img src="/gallery/文件夹-展开.png" class="img_style">
                            </template>
                        </v-treeview>
                    </vuescroll>
                </div>
                <div class="data-arrange-bottom">
                    <v-spacer></v-spacer>
                    <v-btn outlined class="bottom-btn" v-show="active.length" @click="moveFile">确定</v-btn>
                    <v-btn outlined class="bottom-btn" style="margin-right: 20px;margin-left: 10px;" @click="listFile='default'">取消</v-btn>
                </div>
            </div>
            <div v-if="listFile==='search'">
                <div class="path-filter">
                    <div style="float: left;display: flex;">
                        <v-btn v-if="path.length>1" text height="32" style="padding: 14px 0px 4px 15px;" @click="returnLastPath">返回上一级  |</v-btn>
                        <v-breadcrumbs :items="path" divider=">">
                            <template v-slot:item="{ item }">
                                <v-breadcrumbs-item>
                                    <v-btn text @click="returnParent(item.id)">{{item.text}}</v-btn>
                                </v-breadcrumbs-item>
                            </template>
                        </v-breadcrumbs>
                    </div>
                    <v-spacer></v-spacer>
                    <v-text-field
                            outlined dense hide-details label="搜索我的影像库数据" append-icon="mdi-magnify"
                            style="width: 200px;" v-model="keyword" @click:append="searchByKeyword" class="search-arrange"
                    ></v-text-field>
                </div>
                <div class="show-select" style="justify-content: space-between;">
                    <v-checkbox hide-details v-model="isSelectAll" :label="'已选中'+selected.length+'个文件/文件夹'"></v-checkbox>
                    <div style="width: 210px;font-size: 12px;margin-top: 10px;color: #747474;">所在目录</div>
                </div>
                <div class="data-list">
                    <v-progress-linear
                            v-if="load" absolute indeterminate light color="#7FA4FB" style="bottom: 65px;background:#ffffff;height: 6px"
                    ></v-progress-linear>
                    <vuescroll :ops="ops" style="height: 100%;" v-else>
                        <DynamicScroller :items="searchResult" :min-item-size="50" style="height: 100%;">
                            <template v-slot="{ item, index, active }">
                                <DynamicScrollerItem :item="item" :active="active" :data-index="index">
                                    <div style="display: flex;font-size: 12px;margin-left: 15px;">
                                        <v-checkbox hide-details multiple v-model="selected" :value="item.id"></v-checkbox>
                                        <img v-if="!item.dataType" src="/gallery/文件夹-展开.png" class="img_style" style="margin-top: 15px;">
                                        <img v-else-if="item.dataType===1" src="/gallery/压缩包.png" class="img_style" style="margin-top: 14px;">
                                        <img v-else-if="item.dataType===2" src="/gallery/切片图标.png" class="img_style">
                                        <div class="search-item">{{item.name}}</div>
                                        <div v-if="item.parentId" class="catalog" @click="selectParent(item)">{{item.parentName}}</div>
                                    </div>
                                </DynamicScrollerItem>
                            </template>
                        </DynamicScroller>
                    </vuescroll>
                </div>
                <div class="data-arrange-bottom">
                    <v-btn
                            outlined class="bottom-btn" :disabled="buttonState.renameDisabled || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.renameDisabled || renameItem !== '' }"
                            @click="buttonState.renameDisabled? '': showRenameFile()"
                    >重命名</v-btn>
                    <v-btn
                            outlined class="bottom-btn" :disabled="buttonState.moveToDisabled || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.moveToDisabled || renameItem !== '' }"
                            @click="buttonState.moveToDisabled? '': checkMove()"
                    >移动到</v-btn>
                    <v-btn
                            outlined class="bottom-btn" :disabled="buttonState.deleteDisabled || renameItem !== ''"
                            :class="{'button-btn__disabled': buttonState.deleteDisabled || renameItem !== '' }"
                            @click="buttonState.deleteDisabled? '': showDelete()"
                    >删除</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined class="bottom-btn" style="margin-right: 20px;" @click="$store.state.showPanel=false">关闭</v-btn>
                </div>
            </div>
            <v-banner v-if="isBanner" class="banner-bottom" style="background-color: white;color: red;">
                {{ message }}
                <template v-slot:actions>
                    <v-btn text color="primary" @click="isBanner=false">关闭</v-btn>
                </template>
            </v-banner>
            <v-banner v-if="alert" class="banner-bottom" style="background-color: white;">
                文件夹删除后不可恢复，是否确认删除
                <template v-slot:actions>
                    <v-btn text color="primary" @click="deleteFile">确认</v-btn>
                    <v-btn text color="primary" @click="alert=!alert">取消</v-btn>
                </template>
            </v-banner>
        </v-card>
    </div>
</template>
<script>
    import vuescroll from "vuescroll";
    import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
    import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
    
    export default {
        name: "DeliveryDataArrange",
        components: {
            vuescroll, DynamicScroller, DynamicScrollerItem
        },
        data(){
            return {
                listFile: "default", dataList: [], selected: [], alert: false, isSelectAll: false,
                path: [], oldName: "", isBanner: false, message: "", folderList: [],
                keyword: "", searchResult: [], load: false,
                openList: [], fullDataList: {}, active: [],
                noneData: false,
                hoverItem: "", renameItem: "", isCreatingItem: false,
                ops: {
                    bar: {
                        onlyShowBarOnScroll: false,
                        background: "#374C53"
                    }
                }
            }
        },
        computed: {
            buttonState(){
                let state = {
                    renameDisabled: false,
                    moveToDisabled: false,
                    deleteDisabled: false
                };
                if (this.selected.length === 0) {
                    // 没有被选中的
                    return {
                        renameDisabled: true,
                        moveToDisabled: true,
                        deleteDisabled: true
                    }
                } else if (this.selected.length === 1) {
                    // 有一个被选中的
                    this.dataList.forEach(item => {
                        if (item.id === this.selected[0]){
                            if (item.type === "product") {
                                state.renameDisabled = true;
                                state.deleteDisabled = true;
                            }
                        }
                    })
                    return state;
                } else {
                    state.renameDisabled = true;
                    // 有多个被选中的
                    this.dataList.forEach(item => {
                        if (item.id === this.selected[0]){
                            if (item.type === "product") {
                                state.deleteDisabled = true;
                            }
                        }
                    })
                    return state;
                }
            }
        },
        watch: {
            isSelectAll(newVal, oldVal){
                if (this.selected.length === 0 && newVal){
                    // 场景1：全选按钮原来没有被勾选，点击全选按钮
                    let tempSelected = []
                    this.dataList.forEach(item => {
                        tempSelected.push(item.id);
                    })
                    this.selected = tempSelected;
                } else if (this.selected.length > 0 && this.selected.length < this.dataList.length && oldVal){
                    // 场景2：全选按钮原来被选中，同时，列表有部分选中
                    let tempSelected = []
                    this.dataList.forEach(item => {
                        tempSelected.push(item.id);
                    })
                    this.selected = tempSelected;
                    this.$nextTick(() => {
                        this.isSelectAll = true;
                    })
                } else if (oldVal) {
                    // 场景3：列表项也都是勾选上的, 同时，以前勾选上
                    this.selected = [];
                }
            },
            selected(newVal){
                if (newVal.length === 1 && !this.isSelectAll){
                    this.isSelectAll = true;
                } else if (newVal.length === 0) {
                    this.isSelectAll = false;
                }
            },
            keyword(newVal){
                if (!newVal) {
                    this.listFile = "default";
                    this.searchResult = [];
                    this.path = this.path.slice(0, 1);
                }
            },
            dataList(newVal){
                if (newVal.length === 0){
                    this.noneData = true;
                } else {
                    this.noneData = false;
                }
            }
            
        },
        mounted() {
            this.selectParent(this.$store.state.sidebarTargetItem);
            this.initFolderList();
            this.selected.push(this.$store.state.sidebarTargetId);
        },
        methods: {
            initDataList(id){
                this.axios.get("/deliveryService/folderInfo/listFolderList", {
                    params: {
                        parentFolderId: arguments.length === 0? null: id,
                        sortByField: this.$store.state.sortByField,
                        sortDire: this.$store.state.sortDire
                    }
                }).then( res => {
                    let data = res.data.data;
                    this.utils.deepArrange(res.data.data);
                    // 将数据添加到变量path, dataList中
                    this.path.push({
                        text: data.name,
                        id: data.id
                    });
                    if (data.children.length === 0){
                        this.dataList = [];
                    } else {
                        this.dataList = [...data.children]
                        this.renameItem = "";
                    }
                })
            },
            initFolderList(){
                this.axios.get("/deliveryService/folderInfo/listPureFolderList", {
                    params: {
                        sortByField: this.$store.state.sortByField,
                        sortDire: this.$store.state.sortDire
                    }
                }).then( res => {
                    // 临时代码
                    this.utils.deepArrange(res.data.data);
                    this.folderList = [res.data.data];
                })
            },
            enterFolder(item){
                if (item.hasOwnProperty("children") && item.children.length === 0){
                    this.selected = [];
                    this.initDataList(item.id);
                } else {
                    console.log(item);
                }
            },
            returnLastPath(){
                this.selected = [];
                let item = this.path.pop();
                item = this.path.pop();
                this.initDataList(item.id);
                this.keyword = "";
            },
            returnParent(id){
                this.selected = [];
                for (let i = 0; i < this.path.length; i++) {
                    if (this.path[i].id === id) {
                        this.path.splice(i, this.path.length-i);
                        break;
                    }
                }
                this.initDataList(id);
                this.keyword = "";
            },
            moveFileToFolder(aimFolderId, srcFolderId){
                return new Promise(resolve => {
                    this.axios({
                        url: "/deliveryService/folderInfo/foldeMoveTo",
                        method: "post",
                        params: {
                            aimFolderId: aimFolderId,
                            srcFolderId: srcFolderId
                        }
                    }).then( res => {
                        if (res.data.message === "文件名重复不得移动") {
                            this.showBanner("文件名重复不得移动")
                        } else {
                            resolve(srcFolderId);
                        }
                    })
                })
            },
            moveProductToFolder(aimFolderId, productCode){
                return new Promise(resolve => {
                    this.axios({
                        url: "/deliveryService/folderInfo/productMoveTo",
                        method: "post",
                        params: {
                            aimFolderId: aimFolderId,
                            productCode: productCode
                        }
                    }).then( res => {
                        if (res.data.message === "文件名重复不得移动") {
                            this.showBanner("文件名重复不得移动")
                        } else {
                            resolve(productCode);
                        }
                    })
                })
            },
            moveFile(){
                // 校验是否重名
                let type = "";
                let axiosUrls = [];
                // 对每一个id先做校验然后再统一发出移动请求
                for (const id of this.selected) {
                    this.dataList.forEach( item => {
                        if (item.id === id) {
                            type = item.type;
                        }
                    })
                    if (type === "folder") {
                        // 先检查父子关系是否支持，再移动
                        this.axios.get("/deliveryService/folderInfo/checkFolderFatherSonRelationship", {
                            params: {
                                aimFolderId: this.active[0],
                                srcFolderId: id
                            }
                        }).then( res => {
                            if (res.data.data) {
                                this.showBanner("文件夹不可移动到子文件夹中")
                            } else {
                                axiosUrls.push(this.moveFileToFolder(this.active[0], id));
                            }
                        })
                    } else if (type === "product") {
                        axiosUrls.push(this.moveProductToFolder(this.active[0], id));
                    }
                }
                Promise.all(axiosUrls).then(res => {
                    this.refreshData();
                    this.listFile = 'default';
                })
            },
            deleteOneFile(folderId){
                return new Promise(resolve => {
                    this.axios({
                        url: "/deliveryService/folderInfo/deleteFolder",
                        method: "post",
                        params: {
                            folderId: folderId
                        }
                    }).then( res => {
                        if (res.data.message === "不能删除非空文件夹") {
                            this.showBanner("不能删除非空文件夹")
                        } else {
                            resolve(folderId)
                        }
                    })
                })
            },
            deleteFile(){
                this.alert = false;
                let axiosUrls = [];
                for (let i = 0; i < this.selected.length; i++) {
                    let delectId = this.selected[i];
                    // 调用孟欣接口
                    axiosUrls.push(this.deleteOneFile(delectId));
                }
                Promise.all(axiosUrls).then(res => {
                    this.refreshData();
                })
            },
            showRenameFile(){
                let renameFolder = {};
                this.dataList.forEach( item => {
                    if (item.id === this.selected[0] ){
                        renameFolder = item;
                    }
                })
                this.oldName = renameFolder.name;
                this.renameItem = renameFolder.id;
            },
            renameFolder(newFolder) {
                let parent = this.path.pop();
                console.log(parent.id)
                this.axios.get("/deliveryService/folderInfo/checkFolderName", {
                    params: {
                        folderName: newFolder.name,
                        parentId: parent.id
                    }
                }).then( res => {
                    if (!res.data.data) {
                        this.showBanner("文件名不可为空，或同一目录下不可有同名文件或文件夹");
                        this.path.push(parent);
                    } else {
                        this.renameItem = "";
                        this.axios({
                            url: "/deliveryService/folderInfo/renameFolder",
                            method: "post",
                            params: {
                                folderName: newFolder.name,
                                folderId: newFolder.id
                            }
                        }).then( res => {
                            if (res.data.data === 1){
                                this.refreshData();
                            } else {
                                console.log("重命名文件夹", res.data);
                            }
                            
                        })
                    }
                })
            },
            showNewFolder(){
                this.isCreatingItem = true;
                this.dataList.unshift({
                    name: "",
                    type: "folder",
                })
            },
            createFolder(newFolder){
                let parent = this.path.pop();
                this.axios.get("/deliveryService/folderInfo/checkFolderName", {
                    params: {
                        folderName: newFolder.name,
                        parentId: parent.id
                    }
                }).then( res => {
                    if (!res.data.data) {
                        this.path.push(parent);
                        this.showBanner("文件名不可为空，或同一目录下不可有同名文件或文件夹");
                        return;
                    } else {
                        this.axios({
                            url: "/deliveryService/folderInfo/createNewFolder",
                            method: "post",
                            params: {
                                folderName: newFolder.name,
                                parentId: parent.id
                            }
                        }).then( res => {
                            if (res.data.data.length === 32){
                                this.refreshData();
                            } else {
                                console.log("新建文件夹", res.data);
                            }
                        })
                    }
                }).then(res => {
                    this.isCreatingItem = false;
                })
            },
            showBanner(message){
                this.isBanner = true;
                this.message = message;
            },
            showDelete(){
                // 找到要删除的子项
                let deleteList = [];
                this.dataList.forEach(item => {
                    if (this.selected.includes(item.id)) {
                        deleteList.push(item);
                    }
                })
                let hasChildren = false;
                deleteList.forEach(item => {
                    if (item.children.length !== 0) {
                        hasChildren = true;
                    }
                })
                if (hasChildren) {
                    this.showBanner("该文件夹下有数据，不可直接删除，请将数据移到其他文件夹后再操作")
                    return;
                } else {
                    // 有待改善，需要有两个button才行
                    this.alert = true;
                }
            },
            checkMove(){
                this.active = [];
                this.listFile = 'moveFile';
            },
            refreshData(){
                this.selected = [];
                this.isSelectAll = false;
                this.path = [];
                this.eventVue.$emit("showDelivery");
                this.initDataList();
                this.initFolderList();
            },
            searchByKeyword(){
                this.load = true;
                this.listFile = "search";
                this.selected = [];
                this.searchResult = [];
                this.axios("/deliveryService/folderInfo/searchInFolderList", {
                    params: {
                        keyword: this.keyword
                    }
                }).then(res => {
                    this.searchResult = [];  // 未解决极快速连击导致的列表出现空白的现象
                    // 处理路径问题
                    if (this.path.length !== 1){
                        this.path.length = 1;
                    }
                    this.path.push({
                        "text": "搜索“"+this.keyword+"”"
                    });
                    // 整理数据
                    for (const folder of res.data.data.folderSearchDtos) {
                        folder["id"] = folder.folderId;
                        delete folder.folderId;
                        folder["name"] = folder.folderName;
                        delete folder.folderName;
                        this.searchResult.push(folder);
                    }
                    for (const product of res.data.data.productSearchDtos) {
                        product["id"] = product.productCode;
                        delete product.productCode;
                        product["name"] = product.productName;
                        delete product.productName;
                        product["parentId"] = product.parentFolderId;
                        delete product.parentFolderId;
                        product["parentName"] = product.parentFolderName;
                        delete product.parentFolderName;
                        this.searchResult.push(product);
                    }
                    this.load = false;
                })
            },
            selectParent(item){
                if (item.type === "folder"){
                    this.axios.get("/deliveryService/folderInfo/searchFolderFullPath", {
                        params: {
                            folderId: item.id
                        }
                    }).then(res => {
                        this.dealData(res.data.data, res.data.data.length-1);
                    })
                } else if (item.type === "product") {
                    this.axios.get("/deliveryService/folderInfo/searchProductFullPath", {
                        params: {
                            productCode: item.id
                        }
                    }).then(res => {
                        this.dealData(res.data.data, res.data.data.length);
                    })
                } else if (item.parentId){
                    this.axios.get("/deliveryService/folderInfo/searchFolderFullPath", {
                        params: {
                            folderId: item.parentId
                        }
                    }).then(res => {
                        this.dealData(res.data.data, res.data.data.length);
                    })
                }
                
            },
            dealData(parentPath, len){
                // 需要先处理面包屑问题
                if (this.path.length > 0) {
                    this.path = [];
                }
                for (let i = 0; i < len - 1; i++) {
                    this.path.push({
                        id: parentPath[i].folderId,
                        text: parentPath[i].folderName
                    })
                }
                this.listFile = "default";
                this.keyword = "";
                this.initDataList(parentPath[len-1].folderId);
            }
        }
    }
</script>
<style scoped>
    .card-title {
        width: 100%;
        height: 50px;
        padding: 15px 0px;
        font-size: 16px;
        color: #263237;
        font-weight: 700;
        text-align: center;
    }
    .path-filter {
        width: 100%;
        height: 40px;
        padding-right: 30px;
        padding-left: 5px;
        background-color: #F2F2F2;
        display: flex;
        font-size: 12px;
    }
    .path-filter .v-input {
        max-width: 200px;
    }
    .path-filter .v-btn {
        font-size: 12px;
        padding: 0px 6px;
    }
    .show-select {
        padding-left: 16px;
        display: flex;
    }
    .data-arrange-bottom {
        position: relative;
        bottom: 0px;
        width: 100%;
        height: 68px;
        background-color: #F2F2F2;
        padding-left: 16px;
        display: flex;
        flex-direction: row;
    }
    .data-list {
        width: 100%;
        height: 350px;
    }
    .data-list .v-list-item {
        min-height: 0px;
    }
    .data-list .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .data-list .v-btn {
        justify-content: flex-start;
    }
    .banner-bottom {
        position: absolute;
        bottom: 0px;
        width: 100%;
    }
    .bottom-btn {
        margin: 15px 0px 0px 5px;
        color: #329999;
        border: 1px solid #329999;
        cursor:pointer;
    }
    .button-btn__disabled {
        color: #b8b8b8;
        border: 1px solid #b8b8b8;
        cursor: default;
    }
    .img_style {
        width: 20px;
        height: 16px;
        margin-top: 4px;
    }
    .color-control {
        color: #5D9BFC;
    }
    .catalog {
        width: 180px;
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .search-item {
        width: 500px;
        height: 24px;
        margin: 14px 0px 0px 8px;
        ursor: pointer;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>